import { captureMessage } from "@sentry/react";

/**
 * Run a request under an abort timeout. A connection that opens but never
 * responds would otherwise hang forever; on timeout this aborts it so the
 * caller sees a rejection, and reports the stall to Sentry.
 */
export async function withRequestTimeout<T>(
  label: string,
  timeoutMs: number,
  run: (signal: AbortSignal) => Promise<T>
) {
  const controller = new AbortController();
  const timeout = setTimeout(() => {
    captureMessage(`${label} request timed out`, {
      level: "warning",
      tags: { request_timeout: label },
      extra: { timeoutMs },
    });
    controller.abort();
  }, timeoutMs);
  // try/finally so the timer is cleared even if run() throws synchronously.
  try {
    return await run(controller.signal);
  } finally {
    clearTimeout(timeout);
  }
}
